import React, { useEffect, useState } from "react";
import CardBasic from "../components/CardBasic";
import Table from "../components/Table";
import { useMemo } from "react";
import axios from "axios";
import moment from "moment";
import { ExportToExcel, HEADER, GetBalance } from "../utils/Utils";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import ModalLoading from "../components/ModalLoading";
import Select from "react-select";
import ModalInformation from "../components/Modal/ModalInformation";

export default function EwalletFragment() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("dompet_user"));
  const dataOutlet = JSON.parse(localStorage.getItem("dompet_detail_outlet"));
  const [date, setDate] = useState({
    start_at: new Date().setDate(new Date().getDate() - 6),
    end_at: new Date(),
  });
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [showModalInformation, setShowModalInformation] = useState(false);
  const [tableData, setTableData] = useState({
    all_history_transactions: {
      data: [],
    },
  });
  const [pageSelected, setPageSelected] = useState(1);
  const [saldo, setSaldo] = useState({
    ewallet_balance: 0,
    transit_balance: 0,
    deposit_balance: 0,
  });
  const [bankAccount, setBankAccount] = useState({});
  const [isRequire, setIsRequire] = useState({
    is_bank_data_available: true,
  });
  const [options, setOptions] = useState({});
  const [filter, setFilter] = useState({});

  useEffect(() => {
    setShowModalLoading(true);
    GetDataProject();
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (filter.project_id) {
        setShowModalLoading(true);
        await GetBankAccount();
        await GetDataSaldo();
        await GetDataTransaction(false, true);
        setShowModalLoading(false);
      }
    }
    fetchData();
    return () => {
      setTableData({
        all_history_transactions: {
          data: [],
        },
      });
    };
  }, [date, filter]);

  useEffect(() => {
    if (pageSelected > 1) {
      GetDataTransaction();
    }
  }, [pageSelected]);

  const list_data_table = {
    all_history_transactions: {
      key: "all_history_transactions",
      name: "History Transactions",
      url: "/v2/collection/mitra/ewalletTransaction/data",
      navigation: "",
    },
  };

  const GetDataProject = async () => {
    let project = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL_API
      }/v2/collection/project/data?channel_id=${dataOutlet.channel_id ?? ""}`,
      { headers: HEADER },
    );
    let projectList = [
      {
        label: "ALL PROJECT",
        value: project.data.data.map((value) => value.project_id).toString(),
      },
    ].concat(
      project.data.data.map((value) => ({
        label: value.project_alias ?? value.project_name,
        value: value.project_id,
      })),
    );
    setOptions((prevState) => ({
      ...prevState,
      project: projectList,
    }));
    setFilter((prevState) => ({
      ...prevState,
      project_id: projectList[0].value,
    }));
  };

  const GetBankAccount = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL_API}/bankAccount?channel_id=${dataOutlet.channel_id}`,
        {
          headers: HEADER,
        },
      )
      .then((res) => {
        if (!_.isEmpty(res.data.data)) {
          let bank = res.data.data[0];
          setBankAccount(bank);
          // set logic show banner require renew bank data
          setIsRequire((prevState) => ({
            ...prevState,
            is_bank_data_available: !_.isEmpty(bank),
          }));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const GetDataSaldo = async () => {
    try {
      let balance = await GetBalance(
        dataOutlet.channel_id,
        filter.project_id ?? null,
      );
      setSaldo(balance);
    } catch (error) {
      console.error(error);
    }
  };

  const GetDataTransaction = async (isDownload, isRefresh) => {
    Object.keys(list_data_table).forEach(async (key) => {
      let start = isRefresh
        ? 1
        : pageSelected > 1
          ? (pageSelected - 1) * 10 + 1
          : 1;
      await axios
        .get(
          `${process.env.REACT_APP_BASE_URL_API}${
            list_data_table[key].url
          }?channel_id=${dataOutlet.channel_id}&start=${start}&length=10&dompet=1&start_at=${moment(
            date.start_at,
          ).format(
            "YYYY-MM-DD",
          )}&end_at=${moment(date.end_at).format("YYYY-MM-DD")}`,
          {
            headers: HEADER,
          },
        )
        .then((res) => {
          if (isDownload) {
            ExportToExcel("Report Transaction", res.data.data);
          } else {
            var pages = [];
            for (let i = 0; i < Math.ceil((res.data.length - 1) / 10); i++) {
              pages.push(i + 1);
            }
            setTableData((prevState) => ({
              ...prevState,
              [key]: {
                data: res.data.data,
                pages: pages,
                length: res.data.length,
                pageSelected: 0,
              },
            }));
          }
        })
        .catch((error) => {
          console.error(error);
        });
    });
  };

  const columns = {
    all_history_transactions: useMemo(
      () => [
        {
          Header: "Date",
          accessor: "created_at",
          Cell: ({ value }) => (
            <div className="text-center">
              {moment(value).format("DD-MM-YYYY HH:mm")}
            </div>
          ),
        },
        {
          Header: "Type Transaction",
          accessor: "transaction_type",
          Cell: ({ value }) => <div className="text-center">{value}</div>,
        },
        {
          Header: "Nominal",
          accessor: "nominal",
          Cell: ({ value }) => (
            <div className="text-center">
              {parseInt(value).toLocaleString("id-ID", {
                style: "currency",
                currency: "IDR",
              })}
            </div>
          ),
        },
        {
          Header: "Status",
          accessor: "status",
          Cell: ({ value }) => (
            <div className="text-center">
              <div
                className={`inline-flex text-xs font-medium ${
                  value === "success"
                    ? "bg-green-100 text-green-600"
                    : value === "reject" || value === "failed"
                      ? "bg-red-100 text-red-600"
                      : value === "pending"
                        ? "bg-yellow-100 text-yellow-600"
                        : ""
                } rounded-full px-2.5 py-1 text-center`}
              >
                {value ?? "-"}
              </div>
            </div>
          ),
        },
        {
          Header: "Project",
          accessor: "project_name",
          Cell: ({ value }) => (
            <div className="text-center">{value ?? "-"}</div>
          ),
        },
        {
          Header: "Voucher",
          accessor: "voucher_number",
          Cell: ({ value }) => (
            <div className="text-center">{value ?? "-"}</div>
          ),
        },
        {
          Header: "SKU",
          accessor: "sku_name",
          Cell: ({ value }) => (
            <div className="text-center">{value ?? "-"}</div>
          ),
        },
        {
          Header: "Description",
          accessor: "description",
          Cell: ({ value }) => (
            <div className="text-center">{value ?? "-"}</div>
          ),
        },
      ],
      [],
    ),
  };

  const handleChange = (event) => {
    setFilter({
      project_id: event.value,
    });
  };
  return (
    <>
      <ModalInformation
        showModal={showModalInformation}
        setShowModal={setShowModalInformation}
        type="error"
        title="Maintance Sedang dilakukan"
        detail="Terima kasih atas partisipasi Anda yang telah bergabung
                        sebagai Mitra Kartini. Kami ingin menginformasikan bahwa
                        hingga tanggal 5 Januari 2024 kami sedang melakukan
                        peningkatan sistem demi pelayanan yang semakin baik.
                        Peningkatan ini akan menyebabkan dihentikan sementara
                        fungsi withdrawal (penarikan dana). Silahkan kembali
                        melakukan fungsi withdrawal setelah tanggal 5 Januari
                        2024. Kami mohon maaf atas ketidaknyamanan yang mungkin
                        terjadi."
      />
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <div className="space-y-4 pb-10">
        {!isRequire.is_bank_data_available && (
          <div
            className={`flex items-start rounded bg-red-100 px-3 py-2 text-red-600`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mr-2 h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <span className="text-sm">
              Plese register your bank account, to register your bank data
              please go to{" "}
              <a href="/profile" className="text-blue-500 underline">
                Profile
              </a>
            </span>
          </div>
        )}
        <Select
          className="col-span-full sm:col-span-2"
          placeholder="Select Project"
          value={
            filter.project_id &&
            options.project.filter(
              (project) => project.value === filter.project_id,
            )
          }
          options={options.project}
          onChange={handleChange}
        />
        <div className="flex flex-col space-y-4 lg:flex-row lg:space-x-2 lg:space-y-0">
          <CardBasic
            title="E-Wallet"
            information={
              <div className="mt-2 flex items-start space-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-6 w-6 text-[#7D7C7C]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
                  />
                </svg>
                <div className="w-full text-[11px] text-gray-500">
                  E-Wallet adalah jumlah total yang dapat Anda tarik ke rekening
                  bank yang telah didaftarkan. Ada biaya penarikan yang dapat
                  berlaku pada saat penarikan.
                  <span className="ml-1 text-[#ED64BD]">
                    Minimum penarikan (withdrawal) sebesar Rp. 12,000.
                  </span>
                </div>
              </div>
            }
          >
            <>
              <div className="mx-5 my-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-500">E-Wallet Balance</p>
                    <h5 className="text-2xl font-bold">
                      {parseInt(saldo.ewallet_balance).toLocaleString("id-ID", {
                        style: "currency",
                        currency: "IDR",
                      })}
                    </h5>
                  </div>
                  <button
                    className="btn-sm bg-[#6FEDB6] text-white shadow-none disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400"
                    onClick={() => {
                      navigate("/withdraw", {
                        state: {
                          detailVoucher: {},
                          saldo: saldo,
                          bankAccount: bankAccount,
                        },
                      });
                    }}
                    // onClick={() => setShowModalInformation(true)}
                    disabled={
                      !isRequire.is_bank_data_available ||
                      user.user_type !== "admin"
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="mr-2 h-4 w-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
                      />
                    </svg>
                    Withdraw
                  </button>
                </div>
              </div>
            </>
          </CardBasic>
          <CardBasic
            title="Deposit"
            information={
              <div className="mt-2 flex items-start space-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-6 w-6 text-[#7D7C7C]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
                  />
                </svg>
                <div className="w-full text-[11px] text-gray-500">
                  Deposit adalah total anggaran yang telah dialokasikan untuk
                  kegiatan di toko Anda. Deposit dapat berubah tanpa
                  pemberitahuan sebelumnya.
                </div>
              </div>
            }
          >
            <>
              <div className="mx-5 my-4">
                <p className="text-sm text-gray-500">Deposit Balance</p>
                <h5 className="text-2xl font-bold">
                  {parseInt(saldo.deposit_balance).toLocaleString("id-ID", {
                    style: "currency",
                    currency: "IDR",
                  })}
                </h5>
              </div>
            </>
          </CardBasic>
          <CardBasic
            title="Transit"
            information={
              <div className="mt-2 flex items-start space-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-6 w-6 text-[#7D7C7C]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
                  />
                </svg>
                <div className="w-full text-[11px] text-gray-500">
                  Transit adalah jumlah total yang sedang dalam proses approval
                  lalu akan di teruskan ke E-wallet balance.
                </div>
              </div>
            }
          >
            <>
              <div className="mx-5 my-4">
                <p className="text-sm text-gray-500">Transit Balance</p>
                <h5 className="text-2xl font-bold">
                  {parseInt(saldo.transit_balance ?? 0).toLocaleString(
                    "id-ID",
                    {
                      style: "currency",
                      currency: "IDR",
                    },
                  )}
                </h5>
              </div>
            </>
          </CardBasic>
        </div>
        <Table
          data={tableData.all_history_transactions.data ?? []}
          pages={tableData.all_history_transactions.pages ?? []}
          setPageSelected={setPageSelected}
          pageSelected={pageSelected ? pageSelected - 1 : 0}
          title="History Transactions"
          columns={columns.all_history_transactions}
          enDatepicker={true}
          isLoading={false}
          date={date}
          setDate={setDate}
        />
        <button
          className={`btn-lg w-full bg-[#4CA6F8] text-white disabled:cursor-not-allowed disabled:bg-[#CCCCCC] disabled:text-[#7D7C7C]`}
          disabled={showModalLoading}
          onClick={() => GetDataTransaction(true)}
        >
          {showModalLoading ? (
            <>
              <svg
                className="h-4 w-4 flex-shrink-0 animate-spin fill-current"
                viewBox="0 0 16 16"
              >
                <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
              </svg>
              <span className="ml-2">Loading...</span>
            </>
          ) : (
            <>
              <span className="ml-2">DOWNLOAD REPORT</span>
            </>
          )}
        </button>
      </div>
    </>
  );
}
